import BaseInteractionService from '@configuratorware/configurator-frontendgui/App/Services/InteractionService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { SaveTypes } from '@configuratorware/configurator-frontendgui/App/configuration';

class InteractionService extends BaseInteractionService {
  async saveAndReturn() {
    const { configurator } = Services;
    await configurator.captureAndSaveConfiguration(SaveTypes.USER);
    const { code } = configurator.state.configuration;
    this.postMessageToContainer({
      method: 'configurationsaveandreturn',
      code,
    });
  }
}

export default InteractionService;
